export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.screen)+'" data-hook="screen-block"> <div class="'+(props.styles.screenTopBackground)+'" data-hook="screen-top-background"> </div> <div class="'+(props.styles.screenBottomBackground)+'" data-hook="screen-bottom-background"> </div></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/screen/templates/screen.dot
// module id = 133
// module chunks = 0 1 2 3 4